import shared from "../../../shared/caller-languages.json";

// The languages an agent's callers may speak, config.settings.callerLanguages (owner, 2026-10-29): the repo-root
// shared/caller-languages.json, Google's list for Gemini transcription, which the bot holds its own codes to. On 3.8
// Live the bot sends them, most spoken first, as the caller transcription's language codes; with none, Gemini guesses
// the language of every caller turn. On a text model they say which languages Deepgram hears, when it is the agent's
// transcriber (owner, 2026-10-31; constants/transcribers.ts).
export const CALLER_LANGUAGES: ReadonlyArray<{ code: string; name: string }> = shared.languages;

/** The line under Caller Languages (the top of Voice Settings: 3.8 Live, or a text model heard by Deepgram). */
export const CALLER_LANGUAGES_HELP =
  "The languages your callers speak, most common first. Speech recognition expects these, so short replies are not " +
  "transcribed in the wrong language. Leave it empty to detect the language on every reply.";

/** What Caller Languages says while none is set. */
export const CALLER_LANGUAGES_NONE = "None set: the language is detected on every reply.";

/** The same two lines on a text model heard by Deepgram, which hears only the languages listed. */
export const CALLER_LANGUAGES_DEEPGRAM_HELP = "The languages your callers speak, most common first. Deepgram hears only these.";
export const CALLER_LANGUAGES_DEEPGRAM_NONE =
  "None set: calls use Gemini Transcribe Live until you add the language your callers speak.";

/**
 * A stored settings.callerLanguages as the list shows it, read as the bot reads it: the codes CALLER_LANGUAGES has
 * (case and surrounding spaces ignored), in their order, each once. A code it does not have, or anything but a list,
 * is left out, as the bot leaves it out, so Publish saves what calls are sent.
 */
export function callerLanguagesOf(stored: unknown): string[] {
  const codes: string[] = [];
  for (const value of Array.isArray(stored) ? stored : []) {
    const key = typeof value === "string" ? value.trim().toLowerCase() : "";
    const code = CALLER_LANGUAGES.find((language) => language.code.toLowerCase() === key)?.code;
    if (code !== undefined && !codes.includes(code)) codes.push(code);
  }
  return codes;
}

/** A language's name, or the code itself for one the list does not have. */
export const callerLanguageName = (code: string): string =>
  CALLER_LANGUAGES.find((language) => language.code === code)?.name ?? code;

/** The languages a search leaves, in the list's order (owner, 2026-11-02): it matches a name or a code, case ignored. */
export function findCallerLanguages(search: string): ReadonlyArray<{ code: string; name: string }> {
  const term = search.trim().toLowerCase();
  return CALLER_LANGUAGES.filter(
    (language) => language.name.toLowerCase().includes(term) || language.code.toLowerCase().includes(term),
  );
}

/** What the Add button of the language dialog says for how many are ticked. */
export const addLanguagesLabel = (count: number): string =>
  count === 0 ? "Add languages" : `Add ${count} ${count === 1 ? "language" : "languages"}`;
